import {
  Box, Button, FormControl, FormErrorMessage, FormLabel, Heading,
  Input, InputGroup, InputRightElement,
  VStack, useToast
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

function LoginPage() {
  const navigate = useNavigate()
  const toast = useToast()

  const [user, setUser] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({ user: '', password: '' })

  const validateLoginForm = () => {
    const newErrors = { user: '', password: '' }
    if (!user) newErrors.user = 'Usuário obrigatório'
    if (!password) newErrors.password = 'Senha obrigatória'
    setErrors(newErrors)
    return !newErrors.user && !newErrors.password
  }

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!validateLoginForm()) return
    setIsLoading(true)

    // ✅ Login Hardcode
    if (user === 'sabri' && password === 'SabriEventos0610') {
      localStorage.setItem('isAuthenticated', 'true')
      toast({
        title: 'Login realizado com sucesso!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      navigate('/admin') // Rota protegida
    } else {
      toast({
        title: 'Erro no login',
        description: 'Usuário ou senha inválidos!',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
    setIsLoading(false)
  }

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
      <Box w="full" maxW="md" textAlign="center" p={4}>
        <Heading as="h1" size="2xl" mb={8}>Bem-vindo!</Heading>
        <VStack spacing={6} align="stretch">
          <FormControl isInvalid={!!errors.user}>
            <FormLabel>Usuário</FormLabel>
            <Input value={user} onChange={(e) => setUser(e.target.value)} />
            {errors.user && <FormErrorMessage>{errors.user}</FormErrorMessage>}
          </FormControl>
          <FormControl isInvalid={!!errors.password}>
            <FormLabel>Senha</FormLabel>
            <InputGroup>
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement width="3rem">
                <Button variant="ghost" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </Button>
              </InputRightElement>
            </InputGroup>
            {errors.password && <FormErrorMessage>{errors.password}</FormErrorMessage>}
          </FormControl>
          <Button colorScheme="blue" onClick={handleLogin} isLoading={isLoading}>
            Entrar
          </Button>
        </VStack>
      </Box>
    </Box>
  )
}

export default LoginPage
